<template>
  <div>
    <Header :title="$t('setting.set_money_pwd')" />
    <div class="full-page-box">
      <div class="frm-box">
        <van-form>
          <div class="item">
            <p class="title">{{ $t("setting.money_place") }}</p>
            <van-password-input
              :value="opw"
              :length="4"
              :gutter="10"
              :focused="oshowKeyboard"
              @focus="
                oshowKeyboard = true;
                tshowKeyboard = false;
              "
            />
            <van-number-keyboard
              v-model="opw"
              :show="oshowKeyboard"
              @input="
                opw.length !== 3
                  ? (oshowKeyboard = true)
                  : (tshowKeyboard = true)
              "
              @blur="oshowKeyboard = false"
            />
          </div>
          <div class="item">
            <p class="title">{{ $t("setting.money_again_place") }}</p>
            <van-password-input
              :value="tpw"
              :length="4"
              :gutter="10"
              :focused="tshowKeyboard"
              @focus="
                tshowKeyboard = true;
                oshowKeyboard = false;
              "
            />
            <van-number-keyboard
              v-model="tpw"
              :show="tshowKeyboard"
              @input="
                tpw.length !== 3
                  ? (tshowKeyboard = true)
                  : (tshowKeyboard = false);
                oshowKeyboard = false;
              "
              @blur="tshowKeyboard = false"
            />
          </div>
          <div style="margin-top: 16px">
            <van-button class="btn" @click="setPayPassword">Xác nhận</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Header from "@/components/header/index.vue";
import { Toast } from "vant";
export default {
  name: "ChangePayPwd",
  components: { Header },
  data() {
    return {
      opw: "",
      tpw: "",
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo: {},
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    }else {
      this.getUserInfo();
    }
  },
  methods: {
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if(this.opw.length !== 4){
        this.oshowKeyboard = true;
        Toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.tpw.length !== 4){
        this.tshowKeyboard = true;
        Toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.opw !== this.tpw){
        Toast(this.$t("setting.prefect"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        }).then(res=>{
          if(res.code == 200){
                Toast(res.msg);

          }else {
            Toast(res.msg);
          }
        })
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code == 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else {
            Toast(res.msg);
        }
      })
    }
  },
};
</script>
  <style scoped>
.frm-box {
  width: 94%;
  margin: 10px auto;
  padding: 10px;
}
.frm-box .icon-item {
  color: rgb(4 109 181);
  font-size: 18px;
}
.frm-box .input {
  border: 1px solid rgb(4 109 181) !important;
  border-radius: 8px;
  margin-bottom: 15px;
}
.frm-box .btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181) !important;
  border-radius: 8px;
  color: #fff;
  width: 100%;
}
</style>
  